module.exports = __webpack_public_path__ + "static/media/sneakerAnimation2.6882a59f.mp4";